import { Horse_show } from './horse_show';

export class Circuit {
	id: string;
	competition_organizer_id: string;
	start_date: Date;
	end_date: Date;
	name: string;
	description: string;
	allow_copy_entry: boolean;
	horse_show_list: Horse_show[] = [];

	current_horse_show: Horse_show;
	future_horse_shows: Horse_show[] = [];
	past_horse_shows: Horse_show[] = [];

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}